<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ label.get("integrations") }}</h3>
      </div>

      <!-- <div v-if="!shouldPreventNavigation" class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{
              label.get("integration_mileage_tracking")
            }}</label>
          </div>

          <a href="https://pathmile.com/teams" target="_blank" class="view-btn">
            <i class="atto atto atto-rdir-arrow-b" />
            {{ label.get("learn_more") }}
          </a>
        </div>
        <div class="info-field">
          <div class="content-holder">
            <div class="description">
              <p>
                {{ label.get("integration_mileage_tracking_description") }}
                {{ label.get("integration_mileage_tracking_description_two") }}
              </p>
              <hr />
              <a href="" class="logo-holder pathmile-logo" />
            </div>
            <div v-if="loaded" class="button-holder">
              <a
                v-if="!pathmileConnected"
                :href="pathmileConnectUrl"
                class="atto-btn md-btn submit"
              >
                {{ label.get("connect") }}
              </a>
              <p
                v-if="!pathmileConnected"
                v-html="label.get('integration_mileage_get_50_off')"
              />

              <div v-if="pathmileConnected" class="connected">
                <span>
                  <i class="atto atto-selected-tick" />
                  {{ label.get("connected") }}
                </span>
                <a
                  href="javascript:void(0);"
                  class="connect"
                  @click="disconnectPathmile"
                  >{{ label.get("integration_disconnect") }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('integration_mileage_tracking')}}</label>
          </div>

          <a
              href="https://pathmile.com/teams"
              target="_blank"
              class="view-btn"
          >
            <i class="atto atto atto-rdir-arrow-b" />
            {{label.get('learn_more')}}
          </a>
        </div>
        <div class="info-field">
          <div class="content-holder">
            <div class="description">
              <p>
                {{label.get('integration_mileage_tracking_description')}}
                {{label.get('integration_mileage_tracking_description_two')}}
              </p>
              <hr />
              <a
                  href=""
                  class="logo-holder pathmile-logo"
              />
            </div>
            <div
                v-if="loaded"
                class="button-holder"
            >
              <a
                  v-if="!pathmileConnected"
                  :href="pathmileConnectUrl"
                  class="atto-btn md-btn submit"
              >
                {{label.get('connect')}}
              </a>
              <p v-if="!pathmileConnected" v-html="label.get('integration_mileage_get_50_off')" />

              <div
                  v-if="pathmileConnected"
                  class="connected"
              >
                <span>
                  <i class="atto atto-selected-tick" />
                  {{label.get('connected')}}
                </span>
                <a
                    href="javascript:void(0);"
                    class="connect"
                    @click="disconnectPathmile"
                >{{label.get('integration_disconnect')}}</a>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{
              label.get("integration_payroll")
            }}</label>
          </div>

          <a
            href="https://help.attotime.com/article/86-how-to-integrate-to-quickbooks-online"
            target="_blank"
            class="view-btn"
          >
            <i class="atto atto atto-rdir-arrow-b" />
            {{ label.get("learn_more") }}
          </a>
        </div>
        <div class="info-field">
          <div class="content-holder">
            <div class="description">
              <p>
                {{ label.get("integration_payroll_description") }}
              </p>
              <hr />
              <a href="" class="logo-holder quickbooks-logo" />
            </div>
            <div v-if="loaded" class="button-holder right-aligned">
              <a
                v-if="!quickbooksConnected"
                :href="quickbooksConnectUrl"
                class="quickbooks-connect"
                target="_blank"
              />
              <div v-if="quickbooksConnected" class="connected">
                <span>
                  <i class="atto atto-selected-tick" />
                  {{ label.get("connected") }}
                </span>
                <a
                  href="javascript:void(0);"
                  class="connect"
                  @click="disconnectQuickbookModal"
                  >{{ label.get("disconnect") }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="info-field b-info-field">
          <div class="content-holder">
            <div class="description">
              <p>
                Streamline your timesheet exports and automate payroll with an
                integration to Xero. With the single click of a button, all of
                your team’s hours will be exported to your Xero account and be
                ready for payroll. Atto currently integrates to Xero accounts in
                Australia and the United Kingdom only.
              </p>
              <ul
                v-if="xeroName"
                :class="[
                  isConnectedToXero ? 'connected-xero' : 'not-connected-xero',
                ]"
              >
                <li>{{ xeroName }}</li>
              </ul>

              <hr />
              <a href="" class="logo-holder xero-logo"></a>
            </div>
            <div v-if="loaded" class="button-holder right-aligned">
              <a
                v-if="!isConnectedToXero"
                :href="xeroConnectUrl"
                class="xero-connect"
                target="_blank"
              ></a>
              <div class="d-flex" v-if="isConnectedToXero">
                <a
                  href="javascript:void(0);"
                  class="xero-disconnect"
                  @click="disconnectXeroModal"
                ></a>
              </div>
              <!--  <div
                    class="connected"
                    v-if="isConnectedToXero"
                >
                   <span>
                    <i class="atto atto-selected-tick" />
                    {{label.get('connected')}}
                  </span>
                  <a
                      href="javascript:void(0);"
                      class="connect"
                      @click="disconnectXeroModal"
                  >
                    {{label.get('disconnect')}}
                  </a>
                </div>-->
            </div>
          </div>
        </div>
      </div>

      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{
              label.get("upcoming_integrations")
            }}</label>
          </div>
        </div>
        <div class="info-field">
          <div class="content-holder">
            <div class="description">
              <!-- <a href="" class="logo-holder quickbooks-logo"></a>-->
              <p>
                {{ label.get("upcoming_integrations_description") }}
              </p>
              <hr />
              <label class="coming-soon-label"
                >{{ label.get("coming_soon") }}...</label
              >
            </div>
            <div class="button-holder">
              <a
                href="javascript:void(0)"
                class="connect add-request"
                @click="feedbackAndSupport"
                >{{ label.get("add_request") }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IntegrationService from "./IntegrationService";
import PathmileDisconnectComponent from "./components/PathmileDisconnectComponent";

export default {
  name: "IntegrationsComponent",
  components: {
    PathmileDisconnectComponent,
  },
  data() {
    return {
      loaded: false,
      pathmileConnected: false,
      pathmileConnectUrl: "",
      quickbooksConnected: this.$store.state.isConnectedToQuickbooks,
      quickbooksConnectUrl: "",
      xeroConnected: this.$store.state.isConnectedToXero,
      xeroName: null,
      xeroConnectUrl: "",
      showPathmileDisconnect: false,
    };
  },
  computed: {
    isConnectedToXero() {
      return this.$store.state.isConnectedToXero;
    },
    xeroHasError403() {
      return this.$store.state.xeroHasError403;
    },
    shouldPreventNavigation() {
      return this.$route.query.token || false;
    },
  },
  created() {
    if (
      !this.$store.state.user.is_owner &&
      this.$store.state.user.role_id !== 1
    ) {
      this.$router.push({ path: "/activity" });
    } else {
      this.getConnectedIntegrations();
    }
  },
  mounted() {
    this.$root.$on("hideDisconnectPathmile", this.hideDisconnectPathmile);
    this.$root.$on(
      "hideDisconnectQuickbookAccount",
      this.hideDisconnectQuickbookAccount
    );
  },
  methods: {
    getConnectedIntegrations() {
      IntegrationService.getConnectedIntegrations()
        .then((result) => {
          this.pathmileConnected = result.pathmile;
          this.pathmileConnectUrl = result.pathmileConnectUrl;
          this.quickbooksConnected = result.quickbooks;
          this.quickbooksConnectUrl = result.quickbooksConnectUrl;
          this.xeroConnected = result.xero;
          this.$store.state.isConnectedToXero = result.xero;
          this.xeroName = result.xero_name;
          this.xeroConnectUrl = result.xeroConnectUrl;
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    feedbackAndSupport() {
      this.$root.$emit("showFeedbackModal");
    },
    disconnectQuickbookModal() {
      this.$root.$emit("showDisconnectQuickbookAccount");
    },
    disconnectXeroModal() {
      this.$root.$emit("showDisconnectXeroAccount");
    },
    disconnectPathmile() {
      this.showPathmileDisconnect = true;
    },
    hideDisconnectQuickbookAccount() {
      this.quickbooksConnected = false;
    },
    hideDisconnectPathmile(disconnected) {
      if (disconnected) {
        this.pathmileConnected = false;
      }
      this.showPathmileDisconnect = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.company-name {
  h4 {
    padding: 40px 0;
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
  }
}
.info-field {
  .content-holder {
    display: flex;
    justify-content: space-between;
    padding: 24px 40px 32px;

    .description {
      max-width: 670px;
      width: 54%;
      display: flex;
      flex-flow: column;
      flex-direction: column-reverse;

      p {
        font: 400 0.875rem/1.25rem "Roboto", sans-serif;
        margin: 0;
        color: #666666;
        min-height: 61px;
      }
      hr {
        margin: 20px 0 30px;
        width: 71px;
      }
      .coming-soon-label {
        color: $atto-green;
        font: $roboto-medium 1rem/1.1875rem $roboto-font;
        margin: 0;
      }
    }
    .button-holder {
      max-width: 240px;
      width: 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: flex-start;

      &.right-aligned {
        display: flex;
        align-items: flex-end;
      }

      a {
        text-transform: uppercase;
        &.connect {
          background-color: #ffffff;
          color: $atto-font-color;
          width: 100%;
          border: 2px solid $atto-light-grey;
          text-align: center;
          text-transform: uppercase;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font: $roboto-bold 1rem/1.1875rem $roboto-font;
          webkit-transition: ease all 0.1s;
          -moz-transition: ease all 0.1s;
          -ms-transition: ease all 0.1s;
          -o-transition: ease all 0.1s;
          transition: ease all 0.1s;
          &:hover {
            color: #ffffff;
            background-color: $atto-font-color;
          }
        }
      }
      p {
        font: $roboto-regular 0.875rem/1rem $roboto-font;
        text-align: center;
        display: flex;
        flex-flow: column;
        margin-top: 20px;
        width: 125px;
        color: $atto-not-active;
        span {
          font-size: 1rem;
          line-height: 1.1875rem;
          color: $atto-green !important;
          font-weight: $roboto-medium;
          margin-bottom: 4px;
        }
      }
      .connected {
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        span {
          width: 100%;
          height: 40px;
          background-color: transparent;
          color: $atto-font-color;
          font: $roboto-bold 1rem/1.1875rem $roboto-font;
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
          border: 2px solid $atto-light-grey;

          i {
            font-size: 0.625rem;
            margin-right: 7px;
          }
        }
        a {
          height: auto;
          background-color: transparent;
          color: $atto-font-color;
          text-transform: capitalize;
          text-decoration: none;
          font: $roboto-regular 0.875rem/1rem $roboto-font;
          border: none;
          margin-top: 20px;

          &:hover {
            background-color: transparent;
            color: $atto-green;
            text-decoration: none;
          }
        }
      }
    }
  }
  &.b-info-field {
    .content-holder {
      border-top: 2px solid #efefef;
    }
  }
}

a.logo-holder {
  width: 130px;
  height: 25px;
  display: flex;
  background-size: cover !important;
  background-repeat: no-repeat !important;

  &.pathmile-logo {
    background: url("~@assets/images/pathmile-logo.svg");
  }
  &.quickbooks-logo {
    background: url("~@assets/images/quickbooks-logo.svg");
    height: 24px;
  }
  &.xero-logo {
    background: url("~@assets/images/xero-icon.svg");
    width: 56px;
    height: 56px;
  }
}
a.quickbooks-connect {
  width: 224px;
  height: 56px;
  background-repeat: no-repeat !important;
  background: url("~@assets/images/quickbook-connect.svg");
}
.xero-connect {
  width: 160px;
  height: 40px;
  border-radius: 4px;
  background-size: 160px 36px !important;
  background-repeat: no-repeat !important;
  background: #f4f4f4 url("~@assets/images/xero-connect.png") center;
}
.xero-disconnect {
  width: 160px;
  height: 40px;
  border-radius: 4px;
  background-size: 160px 31px !important;
  background-repeat: no-repeat !important;
  background: #f4f4f4 url("~@assets/images/xero-disconnect.png") center;
}
.xero-dot-connected {
  height: 10px;
  width: 10px;
  background-color: #19a810;
  border-radius: 50%;
  display: inline-block;
  margin-left: 5px;
}
.xero-dot-disconnected {
  height: 10px;
  width: 10px;
  background-color: #d90901;
  border-radius: 50%;
  display: inline-block;
  margin-left: 5px;
}

span.coming-soon {
  font: 500 16px/28px "Roboto", sans-serif;
  color: $atto-font-color;
  margin-bottom: 16px;
  display: flex;
}
.learn-more {
  font: 400 14px/16px "Roboto", sans-serif;
  color: $atto-font-color;
  display: flex;
  margin: 40px 0 24px;
  width: 100%;
  max-width: 103px;

  &:after {
    content: "";
    display: flex;
    width: 16px;
    height: 16px;
    background: url("~@assets/images/combined-shape.svg") center no-repeat;
    background-size: cover;
    position: absolute;
    margin: -1px 78px;
  }
  &:hover {
    color: $atto-green;
  }
}
.view-btn {
  font: $roboto-medium 0.8125rem/0.9375rem $roboto-font;
  color: $atto-font-color;
  display: flex;
  flex-flow: row;
  align-items: center;

  i {
    font-size: 0.5625rem;
    margin-right: 8px;
  }
}

body.de {
  .content-holder {
    .button-holder {
      max-width: 200px;
      a.connect {
        max-width: 100%;
      }
      .connected span {
        width: 100%;
        max-width: 200px;
      }
    }
  }
  .learn-more {
    max-width: 120px;
    &:after {
      margin: -1px 120px;
    }
  }
}
body.fr {
  .content-holder {
    .button-holder {
      max-width: 210px;
      a.connect {
        max-width: 100%;
      }
      .connected span {
        width: 100%;
        max-width: 210px;
      }
    }
  }
  .learn-more {
    &:after {
      margin: -1px 95px;
    }
  }
}
body.es {
  .learn-more {
    max-width: 120px;

    &:after {
      margin: -1px 115px;
    }
  }
}
ul.connected-xero {
  list-style: none;
  margin-bottom: 0.5em;
  font-weight: bold;
}
ul.connected-xero li::before {
  content: "\2022";
  color: #06b879;
  display: inline-block;
  height: 10px;
  width: 10px;
}

ul.not-connected-xero {
  list-style: none;
  margin-bottom: 0.5em;
  font-weight: bold;
}
ul.not-connected-xero li::before {
  content: "\2022";
  color: #e05656;
  display: inline-block;
  height: 10px;
  width: 10px;
}
</style>
